import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import type { Signal } from '@/api/types';
import { Pill } from '@/components/widgets/Pill';
import { fmtTime } from '@/lib/format';
import { cn } from '@/lib/utils';
import { SignalTimeline } from './SignalTimeline';

const STATUS_LABEL: Record<Signal['status'], string> = {
  executed: '已成交',
  skipped_user_status: '跳过 停用',
  skipped_risk: '跳过 风控',
  skipped_session: '跳过 时段',
  failed: '失败',
};
const STATUS_TONE: Record<Signal['status'], 'up' | 'down' | 'warn' | 'neutral'> = {
  executed: 'up',
  skipped_user_status: 'neutral',
  skipped_risk: 'warn',
  skipped_session: 'warn',
  failed: 'down',
};

interface Props {
  signal: Signal;
  fresh?: boolean;
}

export function SignalRow({ signal, fresh }: Props) {
  const [open, setOpen] = useState(false);
  const lots = (n: number) => (n / 100).toFixed(2);

  return (
    <>
      <tr
        className={cn('border-t border-line cursor-pointer row-hover', fresh && 'animate-flash')}
        onClick={() => setOpen((o) => !o)}
      >
        <td className="px-2 py-2 w-6 text-ink-3">
          {open ? <ChevronDown className="h-3.5 w-3.5" /> : <ChevronRight className="h-3.5 w-3.5" />}
        </td>
        <td className="px-3 py-2 num text-xs text-ink-2">{fmtTime(signal.createdAt)}</td>
        <td className="px-3 py-2 num font-medium">{signal.userId}</td>
        <td className="px-3 py-2">
          <Pill tone={signal.userSide === 'BUY' ? 'up' : 'down'}>{signal.userSide}</Pill>
        </td>
        <td className="px-3 py-2 text-right num">{lots(signal.userVolume)}</td>
        <td className="px-3 py-2">
          <Pill tone={signal.followMode === 'REVERSE' ? 'brand' : signal.followMode === 'FOLLOW' ? 'up' : 'neutral'}>
            {signal.followMode}
          </Pill>
        </td>
        <td className="px-3 py-2 text-ink-2 num">
          {signal.realSide ? (
            <>
              {signal.realSide} {signal.realVolume ? lots(signal.realVolume) : '—'}
            </>
          ) : (
            '—'
          )}
        </td>
        <td className="px-3 py-2">
          <Pill tone={STATUS_TONE[signal.status]}>{STATUS_LABEL[signal.status]}</Pill>
        </td>
        <td className="px-3 py-2 text-xs text-ink-3 truncate max-w-[200px]">{signal.skipReason || ''}</td>
      </tr>
      {open && (
        <tr className="border-t border-line bg-bg-3/40">
          <td colSpan={9} className="px-8 py-3">
            <SignalTimeline signal={signal} />
          </td>
        </tr>
      )}
    </>
  );
}
